import React, { useCallback, useState } from 'react';
import { CrudForm } from '../shared/Crud';
import AddressForm from '../shared/AddressForm';
import MessageModal from '../shared/MessageModal';
import { isValidZipCode } from '../../utils/validation';
import { addressNameError } from '../../utils/addressName';

function validateAddress(address) {
    const errors = {};
    const zipCode = (address?.zipCode ?? '').trim();
    const street = (address?.street ?? '').trim();
    const number = (address?.number ?? '').trim();
    const district = (address?.district ?? '').trim();
    const city = (address?.city ?? '').trim();
    const stateAbbr = (address?.stateAbbr ?? '').trim();
    const complement = (address?.complement ?? '').trim();

    if (!zipCode || !isValidZipCode(zipCode)) {
        errors.zipCode = 'Informe um CEP válido (8 dígitos).';
    }
    if (!street) errors.street = 'Rua é obrigatória.';
    if (!number) errors.number = 'Número é obrigatório.';
    if (!district) errors.district = 'Bairro é obrigatório.';
    if (!city) errors.city = 'Cidade é obrigatória.';
    if (!stateAbbr || stateAbbr.length !== 2) {
        errors.stateAbbr = 'UF é obrigatória (2 caracteres).';
    }
    if (complement.length > 100) {
        errors.complement = 'Complemento deve ter no máximo 100 caracteres.';
    }
    const nameError = addressNameError(address?.name);
    if (nameError) errors.addressName = nameError;
    return errors;
}

export default function AddressTemplateForm({ onSubmit, onCancel, customerIdForCep }) {
    const [address, setAddress] = useState({});
    const [errors, setErrors] = useState({});
    const [isSubmitting, setIsSubmitting] = useState(false);
    const [messageModal, setMessageModal] = useState({ open: false, title: 'Aviso', message: '' });

    const handleAddressChange = useCallback((next) => {
        setAddress(next);
        setErrors((prev) => {
            const cleared = { ...prev };
            ['zipCode', 'street', 'number', 'district', 'city', 'stateAbbr', 'complement', 'addressName'].forEach((k) => {
                if (cleared[k]) cleared[k] = null;
            });
            return cleared;
        });
    }, []);

    const handleSubmit = async () => {
        const nextErrors = validateAddress(address);
        if (Object.keys(nextErrors).length > 0) {
            setErrors(nextErrors);
            return;
        }
        setIsSubmitting(true);
        try {
            await onSubmit(address);
        } catch (err) {
            setMessageModal({
                open: true,
                title: 'Erro',
                message: err?.message || 'Erro ao salvar endereço.',
            });
        } finally {
            setIsSubmitting(false);
        }
    };

    return (
        <>
            {messageModal.open && (
                <MessageModal
                    title={messageModal.title}
                    message={messageModal.message}
                    onClose={() => setMessageModal((m) => ({ ...m, open: false }))}
                />
            )}
            <CrudForm
                title="Novo endereço recorrente"
                onSubmit={handleSubmit}
                onCancel={onCancel}
                isSubmitting={isSubmitting}
            >
                <AddressForm
                    initialAddress={{}}
                    onChange={handleAddressChange}
                    errors={errors}
                    customerId={customerIdForCep ?? null}
                />
            </CrudForm>
        </>
    );
}
